module.exports = __webpack_public_path__ + "static/media/brand-logo.6549f233.svg";